// @ts-nocheck

import { createContext, useContext } from 'react';

type BetGroupFactoryContextProps = {
  isMultichoice: boolean;
};

export const BetGroupFactoryContext = createContext<BetGroupFactoryContextProps>({});

export const useBetGroupFactoryContext = () => useContext(BetGroupFactoryContext);
